import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { styles } from '@sdir/sds';
import { Card } from '../../Atoms';

const WhatsNextCard: React.FC = () => {
  const intl = useIntl();

  return (
    <WhatsNext>
      <h2>{intl.formatMessage({ id: 'whatsNext.heading' })}</h2>
      <Heading>{intl.formatMessage({ id: 'whatsNext.heading.print' })}</Heading>
      <Info>{intl.formatMessage({ id: 'whatsNext.info.print' })}</Info>
      <Heading>{intl.formatMessage({ id: 'whatsNext.heading.time' })} </Heading>
      <Info>{intl.formatMessage({ id: 'whatsNext.info.time' })}</Info>
      <Heading>{intl.formatMessage({ id: 'whatsNext.heading.abroad' })}</Heading>
      <Info>{intl.formatMessage({ id: 'whatsNext.info.abroad' })}</Info>
    </WhatsNext>
  );
};

export default WhatsNextCard;

const WhatsNext = styled(Card)`
  line-height: 1.5;

  h2 {
    margin-top: 0;
  }
`;
const Heading = styled.div`
  font-size: 16px;
  font-family: ${styles.fonts.stfMedium};
  color: ${styles.colors.font.text};
`;
const Info = styled.div`
  font-size: 14px;
  margin-bottom: 3rem;
`;
